// const mapColumnAndRow = (data, columns, borderStyle = 'thin') => {
//   if (!data.length) return { columns: [], values: [] };
//   const hiddenKeys = ['id', 'referenceId'];
//   const filterData = filterIdOrReferenceId(data, hiddenKeys);
//   const tableColumns = columns?.length ? columns : Object.keys(filterData[0]);
//   let filterColumns = tableColumns.map((column) => {
//     return {
//       name: column,
//       // totalsRowLabel: 'Totals:',
//       // totalsRowFunction: 'count',
//       filterButton: true,
//       style: {
//         border: borderConfig(borderStyle),
//         font: {
//           size: 10,
//           bold: false,
//         },
//         alignment: alignmentConfig,
//       },
//     };
//   });

//   const values = filterData?.map((row) =>
//     Object.values(
//       Object.fromEntries(
//         Object.entries(row).filter(([key, _]) => tableColumns.includes(key)),
//       ),
//     ),
//   );

//   return {
//     filterColumns,
//     values,
//   };
// };

import { showToast } from '@/utils/toastMessage/ToastMessage';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';

const borderStyles = {
  thin: 'thin',
  dotted: 'dotted',
  hair: 'hair',
  medium: 'medium',
  double: 'double',
  think: 'think',
  dashed: 'dashed',
  dashDotDot: 'dashDotDot',
  slantDashDot: 'slantDashDot',
  mediumDashed: 'mediumDashed',
  mediumDashDotDot: 'mediumDashDotDot',
  mediumDashDot: 'mediumDashDot',
};

const borderConfig = (style = 'thin') => {
  return {
    top: { style: borderStyles[style] },
    left: { style: borderStyles[style] },
    bottom: { style: borderStyles[style] },
    right: { style: borderStyles[style] },
  };
};

const alignmentConfig = {
  horizontal: 'center',
  vertical: 'middle',
};

const getLastCellAddress = (sheet) => {
  const minCell = 5;
  const maxCell = 10;

  if (sheet.lastColumn.number < minCell || sheet.lastColumn.number > maxCell)
    return 'E';

  return sheet
    .getRow(1)
    .getCell(sheet.lastColumn.number)
    .fullAddress.address.split('')[0];
};

const filterIdOrReferenceId = (data, hiddenKeys) => {
  return data.map((filterData) => {
    return Object.fromEntries(
      Object.entries(filterData).filter(
        ([key, _]) => !hiddenKeys.includes(key),
      ),
    );
  });
};

/**@type {[Object] data} */

const mapColumnAndRow = (data, columns, borderStyle = 'thin') => {
  if (!data.length) return { columns: [], values: [] };

  // Keys to exclude from the export
  const hiddenKeys = ['id', 'referenceId', 'isDefault'];

  // Filter data to exclude hidden keys
  const filterData = filterIdOrReferenceId(data, hiddenKeys);

  // Determine table columns
  const tableColumns = columns?.length ? columns : Object.keys(filterData[0]);

  // Map columns for Excel sheet
  const filterColumns = tableColumns.map((column) => {
    return {
      name: column,
      filterButton: true,
      style: {
        border: borderConfig(borderStyle),
        font: {
          size: 10,
          bold: false,
        },
        alignment: alignmentConfig,
      },
    };
  });

  // Map row values
  // const values = filterData.map((row) =>
  //   Object.values(
  //     Object.fromEntries(
  //       Object.entries(row).filter(([key, _]) => tableColumns.includes(key)),
  //     ),
  //   ),
  // );
  // Map values in order
  const values = filterData?.map((row) => tableColumns.map((col) => row[col]));

  return {
    filterColumns,
    values,
  };
};
const mapTitleColumn = (columns, borderStyle = 'thin') => {
  if (!columns.length) return { columns: [] };

  // Keys to exclude from the export
  const hiddenKeys = ['id', 'referenceId', 'isDefault'];

  // Determine table columns
  const tableColumns = columns;

  // Map columns for Excel sheet
  const filterTitleColumns = tableColumns.map((column) => {
    return {
      name: column,
      filterButton: true,
      style: {
        border: borderConfig(borderStyle),
        font: {
          size: 10,
          bold: false,
        },
        alignment: alignmentConfig,
      },
    };
  });

  // Map row values
  // const values = filterData.map((row) =>
  //   Object.values(
  //     Object.fromEntries(
  //       Object.entries(row).filter(([key, _]) => tableColumns.includes(key)),
  //     ),
  //   ),
  // );
  // Map values in order

  return {
    filterTitleColumns,
  };
};

const saveAsExcel = async (buffer, filename) => {
  try {
    let extension = '.xlsx';
    let type =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    const blob = new Blob([buffer], { type });

    saveAs(blob, filename + extension);
  } catch (error) {
    throw new Error(error);
  }
};

export const createExcelWorkBook = async (
  data = [],
  { companyName, address, phone, email },
  fileName,
  title,
  startDate,
  endDate,
  columns,
  hideDate,
  isTotalBold,
  titleColumn,
  boldRowIndexes = [],
) => {
  const { filterColumns, values } = mapColumnAndRow(data, columns);
  const { filterTitleColumns } = mapTitleColumn(
    (titleColumn && titleColumn) || [],
  );

  if (!filterColumns?.length && !values.length) {
    showToast('There is no data to export', 'Info');
    return;
  }

  const workbook = new Workbook();
  workbook.created = new Date();
  workbook.subject = 'report';
  workbook.company = companyName;
  workbook.creator = companyName;

  workbook.views = [
    {
      x: 0,
      y: 0,
      width: 10000,
      height: 20000,
      firstSheet: 0,
      activeTab: 1,
      visibility: 'visible',
    },
  ];

  // config
  const sheet = workbook.addWorksheet('Sheet', {
    properties: {
      tabColor: { argb: 'FFC0000' },
      views: [{ showGridLines: true }],
    },
    pageSetup: { paperSize: 9, orientation: 'landscape' },
  });

  sheet.properties.outlineLevelCol = 50;
  sheet.properties.defaultRowHeight = 20;
  sheet.properties.defaultColWidth = 15;

  sheet.addTable({
    name: 'Report',
    displayName: 'Report',
    ref: 'A7',
    headerRow: true,
    totalsRow: false,
    style: {
      theme: 'TableStyleMedium3',
      showRowStripes: true,
      showGridLines: true,
    },
    columns: filterTitleColumns?.length ? filterTitleColumns : filterColumns,
    rows: values,
  });

  const lastCellAddress = getLastCellAddress(sheet);

  // header config
  sheet.mergeCells('A1', `${lastCellAddress}2`);
  const header = sheet.getCell('A1');
  header.value = companyName;
  header.font = {
    size: 18,
    bold: true,
  };
  header.alignment = alignmentConfig;
  // header.border = borderConfig('thin')

  // sub header like address
  sheet.mergeCells('A3', `${lastCellAddress}3`);
  const subHeader = sheet.getCell('A3');
  subHeader.value = address;
  // subHeader.border = borderConfig('thin')
  subHeader.alignment = alignmentConfig;
  subHeader.font = {
    size: 10,
    bold: false,
  };

  sheet.mergeCells('A4', `${lastCellAddress}4`);
  const infoHeader = sheet.getCell('A4');
  infoHeader.value = `Phone: ${phone},  Email: ${email}`;
  infoHeader.alignment = alignmentConfig;
  infoHeader.font = {
    size: 8,
    bold: false,
  };

  if (!hideDate) {
    sheet.mergeCells('A6', `${lastCellAddress}6`);
    const reportTitle = sheet.getCell('A6');
    reportTitle.value = `${title} (${startDate} to ${endDate})`;
    reportTitle.alignment = alignmentConfig;
    reportTitle.font = {
      size: 10,
      bold: false,
    };
  }

  // data start form A6
  sheet.getRow(7).font = {
    color: { argb: 'FFFFFFFF' },
    bold: true,
    size: 10,
  };

  const tableHeaders = sheet.getRow(7);
  tableHeaders._cells.forEach((header) => {
    header.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: '4FB08A' },
    };
  });


  boldRowIndexes.forEach((index) => {
    sheet.getRow(8 + index).eachCell((cell) => {
      cell.font = { size: 10, bold: true };
    });
  });

  const lastRow = sheet.lastRow.number;
  sheet.mergeCells(`A${lastRow + 3}`, `B${lastRow + 3}`);
  const footer = sheet.getCell(`A${lastRow + 3}`);
  footer.value = 'Our Software DipArtha, 9860302021';
  footer.font = {
    size: 8,
    bold: false,
  };
  // const lastCol = sheet.lastColumn

  const buffer = await workbook.xlsx.writeBuffer();
  await saveAsExcel(buffer, fileName);
};

export { saveAsExcel, mapColumnAndRow };

const borderConfigT = (style) => ({
  top: { style },
  left: { style },
  bottom: { style },
  right: { style },
});

const alignmentConfigT = {
  vertical: 'middle',
  horizontal: 'center',
  wrapText: true,
};

export const createExcelWorkBookStockLedgerReport = async (
  data = [],
  { companyName, address, phone, email },
  fileName,
  title,
  startDate,
  endDate,
  columns,
  hideDate,
  isTotalBold,
) => {
  if (!data?.length) {
    showToast('There is no data to export', 'Info');
    return;
  }

  const workbook = new Workbook();
  workbook.created = new Date();
  workbook.subject = 'report';
  workbook.company = companyName;
  workbook.creator = companyName;

  workbook.views = [
    {
      x: 0,
      y: 0,
      width: 10000,
      height: 20000,
      firstSheet: 0,
      activeTab: 1,
      visibility: 'visible',
    },
  ];

  const sheet = workbook.addWorksheet('Sheet', {
    properties: {
      tabColor: { argb: 'FFC0000' },
      views: [{ showGridLines: true }],
    },
    pageSetup: { paperSize: 9, orientation: 'landscape' },
  });

  sheet.properties.outlineLevelCol = 50;
  sheet.properties.defaultRowHeight = 20;
  sheet.properties.defaultColWidth = 15;

  // Set column widths to match the UI
  sheet.getColumn('A').width = 8; // S.N.
  sheet.getColumn('B').width = 12; // Date
  sheet.getColumn('C').width = 20; // Party
  sheet.getColumn('D').width = 18; // Transaction Type
  sheet.getColumn('E').width = 10; // INV No.
  sheet.getColumn('F').width = 12; // Receive Set Or Pcs
  sheet.getColumn('G').width = 12; // Receive Gross Weight
  sheet.getColumn('H').width = 12; // Issue Set Or Pcs
  sheet.getColumn('I').width = 12; // Issue Gross Weight
  sheet.getColumn('J').width = 12; // Balance Set Or Pcs
  sheet.getColumn('K').width = 12; // Balance Gross Weight

  const lastCellAddress = 'K';

  // Add company header
  sheet.mergeCells('A1', `${lastCellAddress}2`);
  const header = sheet.getCell('A1');
  header.value = companyName;
  header.font = { size: 18, bold: true };
  header.alignment = alignmentConfigT;

  // Add address
  sheet.mergeCells('A3', `${lastCellAddress}3`);
  const subHeader = sheet.getCell('A3');
  subHeader.value = address;
  subHeader.alignment = alignmentConfigT;
  subHeader.font = { size: 10, bold: false };

  // Add phone and email
  sheet.mergeCells('A4', `${lastCellAddress}4`);
  const infoHeader = sheet.getCell('A4');
  infoHeader.value = `Phone: ${phone}, Email: ${email}`;
  infoHeader.alignment = alignmentConfigT;
  infoHeader.font = { size: 8, bold: false };

  // Add report title with date range
  if (!hideDate) {
    sheet.mergeCells('A6', `${lastCellAddress}6`);
    const reportTitle = sheet.getCell('A6');
    reportTitle.value = `${title} (${startDate} to ${endDate})`;
    reportTitle.alignment = alignmentConfigT;
    reportTitle.font = { size: 10, bold: false };
  }

  // Add grouped headers in row 7
  sheet.getRow(7).values = [
    '',
    '',
    '',
    '',
    '',
    'Receive',
    '',
    'Issue',
    '',
    'Balance',
    '',
  ];
  sheet.mergeCells('F7:G7');
  sheet.mergeCells('H7:I7');
  sheet.mergeCells('J7:K7');

  const groupedHeaders = sheet.getRow(7);
  groupedHeaders._cells.forEach((cell, index) => {
    cell.font = { color: { argb: 'FF000000' }, bold: true, size: 10 };
    cell.alignment = alignmentConfigT;
    if (index >= 5 && index < 7) {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFEACB' }, // Light peach for Receive
      };
    } else if (index >= 7 && index < 9) {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'fffbd7' }, // Light peach for Issue
      };
    } else if (index >= 9) {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'e1f2e4' }, // Light green for Balance
      };
    }
    cell.border = borderConfigT('thin');
  });

  // Add column headers and merge with row 7 for the first 5 columns
  sheet.getRow(8).values = [
    'S.N.',
    'Date',
    'Party',
    'Transaction Type',
    'INV No.',
    'Set Or Pcs',
    'Gross Weight',
    'Set Or Pcs',
    'Gross Weight',
    'Set Or Pcs',
    'Gross Weight',
  ];

  // Merge and set values for the first 5 columns
  sheet.mergeCells('A7:A8');
  sheet.getCell('A7').value = 'S.N.';
  sheet.getCell('A7').fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: '4FB08A' },
  };
  sheet.getCell('A7').font = {
    color: { argb: 'FF000000' },
    bold: true,
    size: 10,
  };
  sheet.getCell('A7').alignment = alignmentConfigT;
  sheet.getCell('A7').border = borderConfigT('thin');

  sheet.mergeCells('B7:B8');
  sheet.getCell('B7').value = 'Date';
  sheet.getCell('B7').fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: '4FB08A' },
  };
  sheet.getCell('B7').font = {
    color: { argb: 'FF000000' },
    bold: true,
    size: 10,
  };
  sheet.getCell('B7').alignment = alignmentConfigT;
  sheet.getCell('B7').border = borderConfigT('thin');

  sheet.mergeCells('C7:C8');
  sheet.getCell('C7').value = 'Party';
  sheet.getCell('C7').fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: '4FB08A' },
  };
  sheet.getCell('C7').font = {
    color: { argb: 'FF000000' },
    bold: true,
    size: 10,
  };
  sheet.getCell('C7').alignment = alignmentConfigT;
  sheet.getCell('C7').border = borderConfigT('thin');

  sheet.mergeCells('D7:D8');
  sheet.getCell('D7').value = 'Transaction Type';
  sheet.getCell('D7').fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: '4FB08A' },
  };
  sheet.getCell('D7').font = {
    color: { argb: 'FF000000' },
    bold: true,
    size: 10,
  };
  sheet.getCell('D7').alignment = alignmentConfigT;
  sheet.getCell('D7').border = borderConfigT('thin');

  sheet.mergeCells('E7:E8');
  sheet.getCell('E7').value = 'INV No.';
  sheet.getCell('E7').fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: '4FB08A' },
  };
  sheet.getCell('E7').font = {
    color: { argb: 'FF000000' },
    bold: true,
    size: 10,
  };
  sheet.getCell('E7').alignment = alignmentConfigT;
  sheet.getCell('E7').border = borderConfigT('thin');

  const subHeaders = sheet.getRow(8);
  subHeaders._cells.forEach((cell, index) => {
    if (index >= 5 && index < 7) {
      cell.font = { color: { argb: 'FF000000' }, bold: true, size: 10 };
      cell.alignment = alignmentConfigT;
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'ffeacb' }, // Light peach for Receive
      };
      cell.border = borderConfigT('thin');
    } else if (index >= 7 && index < 9) {
      cell.font = { color: { argb: 'FF000000' }, bold: true, size: 10 };
      cell.alignment = alignmentConfigT;
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'fffbd7' }, // Light peach for Issue
      };
      cell.border = borderConfigT('thin');
    } else if (index >= 9) {
      cell.font = { color: { argb: 'FF000000' }, bold: true, size: 10 };
      cell.alignment = alignmentConfigT;
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'e1f2e4' }, // Light green for Balance
      };
      cell.border = borderConfigT('thin');
    }
  });

  const rows = data.map((item, index) => [
    index + 1,
    item?.['Date'],
    item['Party'],
    item['Transaction Type'],
    item['INV No.'],
    item['Receive Set Or Pcs'] || 0,
    item['Receive Gross Weight'] || 0,
    item['Issue Set Or Pcs'] || 0,
    item['Issue Gross Weight'] || 0,
    item['Balance Set Or Pcs'] || 0,
    item['Balance Gross Weight'] || 0,
  ]);

  // Applying custom zebra stripes with alternate colors
  rows.forEach((row, rowIndex) => {
    const sheetRow = sheet.getRow(9 + rowIndex);
    sheetRow.values = row;
    sheetRow._cells.forEach((cell) => {
      cell.font = { size: 10, bold: false };
      cell.alignment = alignmentConfigT;
      cell.border = borderConfigT('thin');
      if (rowIndex % 2 === 0) {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FADBD8' }, // Light blue for even rows
        };
      } else {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFFFFF' }, // White for odd rows
        };
      }
    });
  });

  const lastRow = sheet.lastRow.number;

  // Opening Stock
  const isOpeningStock = data?.[0]?.['Party'] === 'Opening Stock';

  if (isOpeningStock) {
    sheet.getRow(lastRow + 2).values = [
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      'Opening Stock :',
      data?.[0]?.['Balance Set Or Pcs'],
      data[0]?.['Balance Gross Weight']?.toFixed(3) || 0,
    ];
    const totalOpeningStock = sheet.getRow(lastRow + 2);
    totalOpeningStock._cells.forEach((cell, index) => {
      if (index === 8) {
        cell.font = { size: 10, bold: true };
        cell.alignment = {
          vertical: 'middle',
          horizontal: 'right',
          wrapText: true,
        };
      } else if (index >= 9) {
        cell.font = { size: 10, bold: true };
        cell.alignment = alignmentConfigT;
      }
      // cell.border = borderConfigT('thin');
    });
  }

  // Total Receive
  sheet.getRow(lastRow + 3).values = [
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    'TOTAL RECEIVE :',
    data?.[0]?.Party === 'Opening Stock'
      ? data
          ?.slice(1)
          .reduce((acc, item) => acc + (+item['Receive Set Or Pcs'] || 0), 0)
      : data?.reduce(
          (acc, item) => acc + (+item['Receive Set Or Pcs'] || 0),
          0,
        ),
    data?.[0]?.Party === 'Opening Stock'
      ? data
          ?.slice(1)
          .reduce((acc, item) => acc + (+item['Receive Gross Weight'] || 0), 0)
      : data?.reduce(
          (acc, item) => acc + (+item['Receive Gross Weight'] || 0),
          0,
        ),
  ];
  const totalReceiveRow = sheet.getRow(lastRow + 3);
  totalReceiveRow._cells.forEach((cell, index) => {
    if (index === 8) {
      cell.font = { size: 10, bold: true };
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'right',
        wrapText: true,
      };
    } else if (index >= 9) {
      cell.font = { size: 10, bold: true };
      cell.alignment = alignmentConfigT;
    }
    // cell.border = borderConfigT('thin');
  });

  // Total Issue
  sheet.getRow(lastRow + 4).values = [
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    'TOTAL ISSUE :',
    data[0]?.Party === 'Opening Stock'
      ? data
          .slice(1)
          .reduce((acc, item) => acc + (+item['Issue Set Or Pcs'] || 0), 0)
      : data.reduce((acc, item) => acc + (+item['Issue Set Or Pcs'] || 0), 0),
    data?.[0]?.Party === 'Opening Stock'
      ? data
          ?.slice(1)
          .reduce((acc, item) => acc + (+item['Issue Gross Weight'] || 0), 0)
      : data?.reduce(
          (acc, item) => acc + (+item['Issue Gross Weight'] || 0),
          0,
        ),
  ];
  const totalIssueRow = sheet.getRow(lastRow + 4);
  totalIssueRow._cells.forEach((cell, index) => {
    if (index === 8) {
      cell.font = { size: 10, bold: true };
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'right',
        wrapText: true,
      };
    } else if (index >= 9) {
      cell.font = { size: 10, bold: true };
      cell.alignment = alignmentConfigT;
    }
    // cell.border = borderConfigT('thin');
  });

  // Balance
  sheet.getRow(lastRow + 5).values = [
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    'BALANCE :',
    data?.[data?.length - 1]?.['Balance Set Or Pcs'] || 0,
    data?.[data.length - 1]?.['Balance Gross Weight']?.toFixed(3) || 0,
  ];
  const balanceRow = sheet.getRow(lastRow + 5);
  balanceRow._cells.forEach((cell, index) => {
    if (index === 8) {
      cell.font = { size: 10, bold: true };
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'right',
        wrapText: true,
      };
    } else if (index >= 9) {
      cell.font = { size: 10, bold: true };
      cell.alignment = alignmentConfigT;
    }
    // cell.border = borderConfigT('thin');
  });

  // Add footer
  sheet.mergeCells(`A${lastRow + 7}`, `B${lastRow + 7}`);
  const footer = sheet.getCell(`A${lastRow + 7}`);
  footer.value = 'Our Software DipArtha, 9860302021';
  footer.font = { size: 8, bold: false };
  footer.alignment = { vertical: 'middle', horizontal: 'left' };

  const buffer = await workbook.xlsx.writeBuffer();
  await saveAsExcel(buffer, fileName);
};

export const createExcelWorkLedgerReport = async (
  data = [],
  { companyName, address, phone, email },
  fileName,
  title,
  startDate,
  endDate,
  columns,
  hideDate,
  isTotalBold,
  totalData,
) => {
  if (!data?.length) {
    showToast('There is no data to export', 'Info');
    return;
  }

  // Before you create headers/rows, add:
  const inferredCols = data.length ? Object.keys(data[0]) : [];

  // Optionally, only include relevant ones (to match your totals map)
  const relevantCols = inferredCols.filter((key) =>
    [
      'S.N.',
      'ledger_name',
      'dr_amount',
      'cr_amount',
      'dr_metal',
      'cr_metal',
      'customer_address',
      'customer_mobile_number',
      'customer_pan_vat',
    ].includes(key),
  );

  const workbook = new Workbook();
  workbook.created = new Date();
  workbook.subject = 'report';
  workbook.company = companyName;
  workbook.creator = companyName;

  workbook.views = [
    {
      x: 0,
      y: 0,
      width: 10000,
      height: 20000,
      firstSheet: 0,
      activeTab: 1,
      visibility: 'visible',
    },
  ];

  const sheet = workbook.addWorksheet('Sheet', {
    properties: {
      tabColor: { argb: 'FFC0000' },
      views: [{ showGridLines: true }],
    },
    pageSetup: { paperSize: 9, orientation: 'landscape' },
  });

  sheet.properties.outlineLevelCol = 50;
  sheet.properties.defaultRowHeight = 20;
  sheet.properties.defaultColWidth = 15;

  sheet.getColumn('A').width = 8;
  sheet.getColumn('B').width = 20;
  sheet.getColumn('C').width = 15;
  sheet.getColumn('D').width = 15;
  sheet.getColumn('E').width = 15;
  sheet.getColumn('F').width = 15;

  const lastCellAddress = 'F';

  sheet.mergeCells('A1', `${lastCellAddress}2`);
  const header = sheet.getCell('A1');
  header.value = companyName;
  header.font = { size: 18, bold: true };
  header.alignment = alignmentConfigT;

  sheet.mergeCells('A3', `${lastCellAddress}3`);
  const subHeader = sheet.getCell('A3');
  subHeader.value = address;
  subHeader.alignment = alignmentConfigT;
  subHeader.font = { size: 10, bold: false };

  sheet.mergeCells('A4', `${lastCellAddress}4`);
  const infoHeader = sheet.getCell('A4');
  infoHeader.value = `Phone: ${phone}, Email: ${email}`;
  infoHeader.alignment = alignmentConfigT;
  infoHeader.font = { size: 8, bold: false };

  if (!hideDate) {
    sheet.mergeCells('A6', `${lastCellAddress}6`);
    const reportTitle = sheet.getCell('A6');
    reportTitle.value = `${title} (${startDate} to ${endDate})`;
    reportTitle.alignment = alignmentConfigT;
    reportTitle.font = { size: 10, bold: false };
  }

  const parentHeaders = {
    'S.N.': 'S.N.',
    ledger_name: 'Ledger Name',
    dr_amount: 'Amount',
    cr_amount: 'Amount',
    dr_metal: 'Metal',
    cr_metal: 'Metal',
    customer_address: 'Customer',
    customer_mobile_number: 'Customer',
    customer_pan_vat: 'Customer',
  };

  const subHeaders = {
    dr_amount: 'Dr Amount',
    cr_amount: 'Cr Amount',
    dr_metal: 'Dr Metal',
    cr_metal: 'Cr Metal',
    customer_address: 'Address',
    customer_mobile_number: 'Mobile Number',
    customer_pan_vat: 'Pan/VAT',
  };
  const parentRow = sheet.getRow(7);
  const subRow = sheet.getRow(8);

  let colIndex = 1;

  while (colIndex <= relevantCols.length) {
    const col = relevantCols[colIndex - 1];

    if (col === 'S.N.' || col === 'Ledger Name') {
      const letter = String.fromCharCode(64 + colIndex);
      sheet.mergeCells(`${letter}7:${letter}8`);
      const parentCell = parentRow.getCell(colIndex);
      parentCell.value = col;

      // Style parent cell
      parentCell.font = { color: { argb: 'FF000000' }, bold: true, size: 10 };
      parentCell.alignment = alignmentConfigT;
      parentCell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '4FB08A' },
      };
      parentCell.border = borderConfigT('thin');

      colIndex++;
      continue;
    }

    // Grouped headers: Amount or Metal
    const group = parentHeaders[col]; // "Amount" or "Metal"
    const groupCols = relevantCols.filter((c) => parentHeaders[c] === group);

    const startLetter = String.fromCharCode(64 + colIndex);
    const endLetter = String.fromCharCode(
      64 + (colIndex + groupCols.length - 1),
    );
    sheet.mergeCells(`${startLetter}7:${endLetter}7`);

    const parentCell = parentRow.getCell(colIndex);
    parentCell.value = group;

    // Style parent cell
    parentCell.font = { color: { argb: 'FF000000' }, bold: true, size: 10 };
    parentCell.alignment = alignmentConfigT;
    parentCell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: '4FB08A' },
    };
    parentCell.border = borderConfigT('thin');

    // Subheaders row
    groupCols.forEach((c, i) => {
      const cell = subRow.getCell(colIndex + i);
      cell.value = subHeaders[c];

      // Style subheader
      cell.font = { color: { argb: 'FF000000' }, bold: true, size: 10 };
      cell.alignment = alignmentConfigT;
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: group === 'Amount' ? { argb: 'FFEACB' } : { argb: 'e1f2e4' },
      };
      cell.border = borderConfigT('thin');
    });

    colIndex += groupCols.length;
  }

  // // 2D Header Rows
  // sheet.mergeCells('A7:A8');
  // sheet.getCell('A7').value = 'S.N.';

  // sheet.mergeCells('B7:B8');
  // sheet.getCell('B7').value = 'Ledger Name';

  // sheet.mergeCells('C7:D7');
  // sheet.getCell('C7').value = 'Amount';

  // sheet.mergeCells('E7:F7');
  // sheet.getCell('E7').value = 'Metal';

  // const topHeaders = ['A7', 'B7', 'C7', 'E7'];
  // topHeaders.forEach((addr) => {
  //   const cell = sheet.getCell(addr);
  //   cell.font = { color: { argb: 'FF000000' }, bold: true, size: 10 };
  //   cell.alignment = alignmentConfigT;
  //   cell.fill = {
  //     type: 'pattern',
  //     pattern: 'solid',
  //     fgColor: { argb: '4FB08A' },
  //   };
  //   cell.border = borderConfigT('thin');
  // });

  // // Subheaders Row
  // const row8 = sheet.getRow(8);
  // row8.getCell(3).value = 'Dr Amount';
  // row8.getCell(4).value = 'Cr Amount';
  // row8.getCell(5).value = 'Dr Metal';
  // row8.getCell(6).value = 'Cr Metal';

  // for (let i = 3; i <= 6; i++) {
  //   const cell = row8.getCell(i);
  //   cell.font = { color: { argb: 'FF000000' }, bold: true, size: 10 };
  //   cell.alignment = alignmentConfigT;
  //   cell.fill = {
  //     type: 'pattern',
  //     pattern: 'solid',
  //     fgColor: i <= 4 ? { argb: 'FFEACB' } : { argb: 'e1f2e4' },
  //   };
  //   cell.border = borderConfigT('thin');
  // }

  // Data Rows
  // const rows = data.map((item) => [
  //   item['S.N.'],
  //   item['Ledger Name'],
  //   item['Dr Amount'] || 0,
  //   item['Cr Amount'] || 0,
  //   item['Dr Metal'] || 0,
  //   item['Cr Metal'] || 0,
  // ]);
  const rows = data.map((item, index) =>
    relevantCols.map((col) => (col === 'S.N.' ? index + 1 : (item[col] ?? 0))),
  );

  rows.forEach((row, rowIndex) => {
    const sheetRow = sheet.getRow(9 + rowIndex);
    sheetRow.values = row;
    sheetRow._cells.forEach((cell) => {
      cell.font = { size: 10, bold: false };
      cell.alignment = alignmentConfigT;
      cell.border = borderConfigT('thin');
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: rowIndex % 2 === 0 ? 'c5f7b5' : 'FFFFFF' },
      };
    });
  });

  const lastRow = sheet.lastRow.number;
  const totalRow = sheet.getRow(lastRow + 1); // row after data
  const diffRowIndex = totalRow._number + 1;

  // // Add Total Row
  // sheet.mergeCells(`A${lastRow + 1}:B${lastRow + 1}`);
  // const totalLabelCell = sheet.getCell(`A${lastRow + 1}`);
  // totalLabelCell.value = 'Total:';
  // totalLabelCell.font = { size: 10, bold: true };
  // totalLabelCell.alignment = alignmentConfigT;
  // totalLabelCell.border = borderConfigT('thin');

  // const totalRow = sheet.getRow(lastRow + 1);
  // totalRow.getCell(3).value = totalData?.totalAmountDr; // Dr Amount
  // totalRow.getCell(4).value = totalData?.totalAmountCr; // Cr Amount
  // totalRow.getCell(5).value = totalData?.totalMetalDr; // Dr Metal
  // totalRow.getCell(6).value = totalData?.totalMetalCr; // Cr Metal

  // for (let i = 3; i <= 6; i++) {
  //   const cell = totalRow.getCell(i);
  //   cell.font = { size: 10, bold: true };
  //   cell.alignment = alignmentConfigT;
  //   cell.border = borderConfigT('thin');
  // }

  // // Add Opening Difference Row
  // sheet.mergeCells(`A${lastRow + 2}:F${lastRow + 2}`);
  // const openingDiffCell = sheet.getCell(`A${lastRow + 2}`);
  // openingDiffCell.value = `Opening Difference: Amount: ${totalData?.differenceAmount}, Metal: ${totalData?.differenceMetal}`;
  // openingDiffCell.font = { size: 10, bold: true };
  // openingDiffCell.alignment = alignmentConfigT;
  // openingDiffCell.border = borderConfigT('thin');

  //total
  const totalsMap = {
    dr_amount: 'totalAmountDr',
    cr_amount: 'totalAmountCr',
    dr_metal: 'totalMetalDr',
    cr_metal: 'totalMetalCr',
  };

  relevantCols.forEach((col, i) => {
    const cellIndex = i + 1;
    if (totalsMap[col]) {
      totalRow.getCell(cellIndex).value = totalData?.[totalsMap[col]] ?? 0;
    } else if (col === 'ledger_name') {
      totalRow.getCell(cellIndex).value = 'Total:';
    }
  });

  // Assuming you already have diffRowIndex calculated
  sheet.mergeCells(
    `A${diffRowIndex}:${String.fromCharCode(64 + relevantCols.length)}${diffRowIndex}`,
  );
  const openingDiffCell = sheet.getCell(`A${diffRowIndex}`);
  openingDiffCell.font = { size: 10, bold: true };
  openingDiffCell.alignment = alignmentConfigT;
  openingDiffCell.border = borderConfigT('thin');
  openingDiffCell.fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'c5f7b5' }, // Green color
  };
  openingDiffCell.value = `Opening Difference: Amount: ${totalData?.differenceAmount}, Metal: ${totalData?.differenceMetal}`;

  // Apply styling

  // Existing Footer (Software Info)
  sheet.mergeCells(`A${lastRow + 7}:B${lastRow + 7}`);
  const footer = sheet.getCell(`A${lastRow + 7}`);
  footer.value = 'Our Software DipArtha, 9860302021';
  footer.font = { size: 8, bold: false };
  footer.alignment = { vertical: 'middle', horizontal: 'left' };

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  saveAs(blob, `${fileName}.xlsx`);
};

export const createExcelWorkLedgerDetailsReport = async (
  data = [],
  { companyName, address, phone, email },
  fileName,
  title,
  startDate,
  endDate,
  columns,
  hideDate,
  isTotalBold,
  totalData,
  totalExcelFooter,
  ledgerName,
) => {
  if (!data?.length) {
    showToast('There is no data to export', 'Info');
    return;
  }

  const inferredCols = data?.length ? Object.keys(data[0]) : [];

  const relevantCols = columns?.length
    ? inferredCols?.filter(
        (key) => columns.includes(key) && key !== 'long_narration',
      )
    : inferredCols?.filter((key) => key !== 'long_narration');

  const workbook = new Workbook();
  workbook.created = new Date();
  workbook.subject = 'report';
  workbook.company = companyName;
  workbook.creator = companyName;

  workbook.views = [
    {
      x: 0,
      y: 0,
      width: 10000,
      height: 20000,
      firstSheet: 0,
      activeTab: 1,
      visibility: 'visible',
    },
  ];

  const sheet = workbook.addWorksheet('Sheet', {
    properties: {
      tabColor: { argb: 'FFC0000' },
      views: [{ showGridLines: true }],
    },
    pageSetup: { paperSize: 9, orientation: 'landscape' },
  });

  sheet.properties.outlineLevelCol = 50;
  sheet.properties.defaultRowHeight = 20;
  sheet.properties.defaultColWidth = 15;

  relevantCols.forEach((col, i) => {
    const colLetter = String.fromCharCode(65 + i);
    const widthMap = {
      transaction_date: 14,
      particular: 25,
      remark: 25,
      vch_no: 18,
      account_name: 30,
      'Vch. Type': 15,
      dr_amount: 15,
      cr_amount: 15,
      running_balance: 15,
      dr_gold: 12,
      cr_gold: 12,
      running_gold_balance: 15,
      dr_silver: 12,
      cr_silver: 12,
      running_silver_balance: 15,
      short_narration: 25,
    };
    sheet.getColumn(colLetter).width = widthMap[col] || 15;
  });

  const lastCellLetter = String.fromCharCode(64 + relevantCols.length);

  sheet.mergeCells('A1', `${lastCellLetter}2`);
  const header = sheet.getCell('A1');
  header.value = companyName;
  header.font = { size: 18, bold: true, color: { argb: 'FF000000' } };
  header.alignment = { vertical: 'middle', horizontal: 'center' };

  sheet.mergeCells('A3', `${lastCellLetter}3`);
  const subHeader = sheet.getCell('A3');
  subHeader.value = address;
  subHeader.alignment = { vertical: 'middle', horizontal: 'center' };
  subHeader.font = { size: 10, bold: false, color: { argb: 'FF000000' } };

  sheet.mergeCells('A4', `${lastCellLetter}4`);
  const infoHeader = sheet.getCell('A4');
  infoHeader.value = `Phone: ${phone}, Email: ${email}`;
  infoHeader.alignment = { vertical: 'middle', horizontal: 'center' };
  infoHeader.font = { size: 8, bold: false, color: { argb: 'FF000000' } };

  sheet.mergeCells('A5', `${lastCellLetter}5`);
  const accountLedgerTitle = sheet.getCell('A5');
  accountLedgerTitle.value = 'ACCOUNT LEDGER';
  accountLedgerTitle.alignment = { vertical: 'middle', horizontal: 'center' };
  accountLedgerTitle.font = {
    size: 12,
    bold: true,
    color: { argb: 'FF000000' },
  };

  if (!hideDate) {
    const midCol = Math.ceil(relevantCols.length / 3);
    const midLetter = String.fromCharCode(64 + midCol);

    sheet.mergeCells(`A6:${midLetter}6`);
    const accountCell = sheet.getCell('A6');
    accountCell.value = `Account: ${ledgerName}`;
    accountCell.alignment = { vertical: 'middle', horizontal: 'left' };
    accountCell.font = { size: 10, bold: true, color: { argb: 'FF000000' } };

    const nextLetter = String.fromCharCode(64 + midCol + 1);
    sheet.mergeCells(`${nextLetter}6:${lastCellLetter}6`);
    const reportTitle = sheet.getCell(`${nextLetter}6`);
    reportTitle.value = `From: ${startDate}  To: ${endDate}`;
    reportTitle.alignment = {
      vertical: 'middle',
      horizontal: 'left',
      wrapText: false,
    };
    reportTitle.font = { size: 10, bold: false, color: { argb: 'FF000000' } };
  }

  const parentHeaders = {
    transaction_date: 'Date',
    particular: 'Type',
    remark: 'Remark',
    vch_no: 'Vch/Bill No.',
    account_name: 'Account',
    'Vch. Type': 'Vch. Type',
    dr_amount: 'Amount',
    cr_amount: 'Amount',
    running_balance: 'Amount',
    dr_gold: 'Gold',
    cr_gold: 'Gold',
    running_gold_balance: 'Gold',
    dr_silver: 'Silver',
    cr_silver: 'Silver',
    running_silver_balance: 'Silver',
    short_narration: 'Short Narration',
  };

  const subHeaders = {
    dr_amount: 'Debit',
    cr_amount: 'Credit',
    running_balance: 'Balance',
    dr_gold: 'Debit',
    cr_gold: 'Credit',
    running_gold_balance: 'Balance',
    dr_silver: 'Debit',
    cr_silver: 'Credit',
    running_silver_balance: 'Balance',
  };

  const topRow = 7;
  const subRow = 8;
  const processedParents = new Set();
  let colIndex = 1;

  relevantCols.forEach((col) => {
    const parent = parentHeaders[col];
    const sub = subHeaders[col];

    if (!sub) {
      sheet.mergeCells(topRow, colIndex, subRow, colIndex);
      const cell = sheet.getCell(topRow, colIndex);
      cell.value = parent || col;
      cell.font = { color: { argb: 'FF000000' }, bold: true, size: 10 };
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center',
        wrapText: true,
      };
      colIndex++;
      return;
    }

    if (!processedParents.has(parent)) {
      const groupCols = relevantCols.filter((c) => parentHeaders[c] === parent);

      sheet.mergeCells(
        topRow,
        colIndex,
        topRow,
        colIndex + groupCols.length - 1,
      );
      const parentCell = sheet.getCell(topRow, colIndex);
      parentCell.value = parent;
      parentCell.font = { color: { argb: 'FF000000' }, bold: true, size: 10 };
      parentCell.alignment = {
        vertical: 'middle',
        horizontal: 'center',
        wrapText: true,
      };

      groupCols.forEach((c, i) => {
        const cell = sheet.getRow(subRow).getCell(colIndex + i);
        cell.value = subHeaders[c];
        cell.font = { color: { argb: 'FF000000' }, bold: true, size: 10 };
        cell.alignment = {
          vertical: 'middle',
          horizontal: 'center',
          wrapText: true,
        };
      });

      colIndex += groupCols.length;
      processedParents.add(parent);
    }
  });

  const numericCols = [
    'dr_amount',
    'cr_amount',
    'running_balance',
    'dr_gold',
    'cr_gold',
    'running_gold_balance',
    'dr_silver',
    'cr_silver',
    'running_silver_balance',
  ];

  const rows = [];
  data.forEach((item) => {
    const mainRow = relevantCols.map((col) =>
      col === 'account_name' ? (item['account_name'] ?? '') : (item[col] ?? ''),
    );
    rows.push({
      values: mainRow,
      hasNarration: !!item['long_narration'],
      narration: item['long_narration'] ?? '',
    });
  });

  let currentRowIndex = 9;

  rows.forEach(({ values, hasNarration, narration }) => {
    const sheetRow = sheet.getRow(currentRowIndex);
    sheetRow.height = 20;

    values.forEach((value, i) => {
      const colKey = relevantCols[i];
      const cell = sheetRow.getCell(i + 1);
      cell.value = value;
      cell.font = { size: 10, bold: false, color: { argb: 'FF000000' } };
      cell.alignment = {
        vertical: 'middle',
        horizontal: numericCols.includes(colKey) ? 'right' : 'left',
        wrapText: true,
      };
    });

    currentRowIndex++;

    if (hasNarration) {
      const narrationRow = sheet.getRow(currentRowIndex);
      const accountColIndex = relevantCols.indexOf('account_name') + 1;

      relevantCols.forEach((col, i) => {
        const cell = narrationRow.getCell(i + 1);
        cell.value = '';
        cell.font = { size: 10, bold: false, color: { argb: '008000' } };
        cell.alignment = {
          vertical: 'middle',
          horizontal: numericCols.includes(col) ? 'right' : 'left',
          wrapText: true,
        };
      });

      if (accountColIndex > 0) {
        const narrationCell = narrationRow.getCell(accountColIndex);
        narrationCell.value = narration;
        narrationCell.font = {
          size: 10,
          bold: false,
          color: { argb: '008000' },
        };
        narrationCell.alignment = {
          vertical: 'middle',
          horizontal: 'left',
          wrapText: true,
        };
      }

      narrationRow.height = 20;
      currentRowIndex++;
    }
  });

  const lastRow = sheet.lastRow.number;

  const drAmountIdx = relevantCols.indexOf('dr_amount') + 1;
  const crAmountIdx = relevantCols.indexOf('cr_amount') + 1;
  const drGoldIdx = relevantCols.indexOf('dr_gold') + 1;
  const crGoldIdx = relevantCols.indexOf('cr_gold') + 1;
  const drSilverIdx = relevantCols.indexOf('dr_silver') + 1;
  const crSilverIdx = relevantCols.indexOf('cr_silver') + 1;
  const runningBalIdx = relevantCols.indexOf('running_balance') + 1;
  const runningGoldIdx = relevantCols.indexOf('running_gold_balance') + 1;
  const runningSilverIdx = relevantCols.indexOf('running_silver_balance') + 1;

  const totalRowIndex = lastRow + 1;
  const totalRow = sheet.getRow(totalRowIndex);
  totalRow.getCell(1).value = 'Total:';
  totalRow.getCell(1).font = { size: 10, bold: true };
  totalRow.getCell(1).alignment = { vertical: 'middle', horizontal: 'left' };

  const totalMap = {
    [drAmountIdx]: totalData?.totalAmountDr,
    [crAmountIdx]: totalData?.totalAmountCr,
    [drGoldIdx]: totalData?.totalGoldDr,
    [crGoldIdx]: totalData?.totalGoldCr,
    [drSilverIdx]: totalData?.totalSilverDr,
    [crSilverIdx]: totalData?.totalSilverCr,
  };

  Object.entries(totalMap).forEach(([colIdx, value]) => {
    if (Number(colIdx) > 0) {
      const cell = totalRow.getCell(Number(colIdx));
      cell.value = value ?? 0;
      cell.font = { size: 10, bold: true, color: { argb: 'FF000000' } };
      cell.alignment = { vertical: 'middle', horizontal: 'right' };
    }
  });

  const closingRowIndex = lastRow + 2;
  const closingRow = sheet.getRow(closingRowIndex);
  closingRow.getCell(1).value = 'Closing:';
  closingRow.getCell(1).font = { size: 10, bold: true };
  closingRow.getCell(1).alignment = { vertical: 'middle', horizontal: 'left' };

  const closingMap = {
    [runningBalIdx]: totalExcelFooter?.[3]?.closing1,
    [runningGoldIdx]: totalExcelFooter?.[3]?.closing2,
    [runningSilverIdx]: totalExcelFooter?.[3]?.closing3,
  };

  Object.entries(closingMap).forEach(([colIdx, value]) => {
    if (Number(colIdx) > 0) {
      const cell = closingRow.getCell(Number(colIdx));
      cell.value = value ?? '0.000';
      cell.font = { size: 10, bold: true, color: { argb: 'FF000000' } };
      cell.alignment = { vertical: 'middle', horizontal: 'right' };
    }
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  saveAs(blob, `${fileName}.xlsx`);
};
